import { apiClient } from './api';
import type {
  MatchHistoryDetail,
  MatchHistoryPage,
  RatingVerificationAction,
  RatingVerificationReason,
} from '../types';

export interface MatchHistoryPageRequest {
  limit?: number;
  cursor?: string | null;
  signal?: AbortSignal;
  expectedUserId?: number | string;
}

function pageParams(request: MatchHistoryPageRequest) {
  return {
    limit: request.limit ?? 30,
    ...(request.cursor ? { cursor: request.cursor } : {}),
  };
}

export async function getMyMatchHistory(request: MatchHistoryPageRequest = {}): Promise<MatchHistoryPage> {
  const response = await apiClient.get<MatchHistoryPage>('/api/v1/web/matches/history', {
    params: pageParams(request),
    signal: request.signal,
    headers: request.expectedUserId == null ? undefined : { 'X-TARK-Expected-User-Id': String(request.expectedUserId) },
  });
  return response.data;
}

export async function getSquadMatchHistory(
  squadId: number | string,
  request: MatchHistoryPageRequest = {}
): Promise<MatchHistoryPage> {
  const response = await apiClient.get<MatchHistoryPage>(`/api/v1/web/matches/squads/${squadId}/history`, {
    params: pageParams(request),
    signal: request.signal,
    headers: request.expectedUserId == null ? undefined : { 'X-TARK-Expected-User-Id': String(request.expectedUserId) },
  });
  return response.data;
}

export async function getMatchHistoryDetail(matchId: string, signal?: AbortSignal, expectedUserId?: number | string): Promise<MatchHistoryDetail> {
  const response = await apiClient.get<MatchHistoryDetail>(
    `/api/v1/web/matches/history/${encodeURIComponent(matchId)}`,
    { signal, headers: expectedUserId == null ? undefined : { 'X-TARK-Expected-User-Id': String(expectedUserId) } }
  );
  return response.data;
}

export async function commandRatingVerification(
  resultVersionId: string,
  command: {
    clientCommandId: string;
    action: RatingVerificationAction;
    reasonCode?: RatingVerificationReason;
  },
  expectedUserId?: number | string
): Promise<void> {
  await apiClient.post(
    `/api/v1/web/ratings/evidence/results/${encodeURIComponent(resultVersionId)}/confirmation`,
    command,
    { headers: expectedUserId == null ? undefined : { 'X-TARK-Expected-User-Id': String(expectedUserId) } }
  );
}
